export default __webpack_public_path__ + "static/media/girl.38e28d73.png";